import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

import {HandoverModel} from "@handover/view-models/handover.model";

@Component({
  selector: 'handoverm-handover-comments',
  templateUrl: './handover-comments.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HandoverCommentsComponent implements OnInit {

  @Input() model?: HandoverModel;

  constructor() {
  }


  ngOnInit(): void {
  }

}
